import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";

export const Wrap = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  ${({ theme }) => `
    @media(max-width: ${theme.mobileBp}) {
      -webkit-overflow-scrolling: touch;
      justify-content: flex-start;
      flex-wrap: nowrap;
      overflow-x: auto;
    } 
  `}
`;
export const Item = styled.li`
  margin: 7px;
  :first-child {
    margin-left: 0;
  }
  :last-child {
    margin-right: 0;
  }
  @media (max-width: ${({ theme }) => theme.mobileBp}) {
    margin: 4px;
  }
`;

export const Link = styled(RouterLink)`
  border-radius: 24px;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  background-color: ${({ $isActive }) =>
    $isActive ? "var(--bg-touchable-active)" : "var(--bg-touchable)"};
  color: ${({ $isActive }) =>
    $isActive ? "var(--font-color-touchable-active)" : "var(--font-color-touchable)"};
  padding: 12px 15px;
`;
